import { createSelector } from 'reselect'
import endOfDay from 'date-fns/endOfDay'
import { fromZonedTime } from 'date-fns-tz'

import API from '../api/api'

const SET_REQUESTS = 'SET_REQUESTS'
const SET_REQUEST = 'SET_REQUEST'
const UPDATE_REQUEST = 'UPDATE_REQUEST'
const SET_STATS = 'SET_STATS'

const initialState = {
  requests: [],
  request: null,
  allCount: undefined,
  completedCount: undefined,
  pendingCount: undefined,
  scheduledCount: undefined,
}

const updateRequestState = (state, { updatedRequest }) =>
  state.requests.map((request) => {
    if (request.id === updatedRequest.id) {
      return { ...updatedRequest, clientId: request.clientId }
    }
    return request
  })

const maintenanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REQUESTS:
      return {
        ...state,
        requests: action.requests,
      }
    case SET_REQUEST:
      return {
        ...state,
        request: action.request ? { ...state.request, ...action.request } : action.request,
      }
    case SET_STATS:
      return {
        ...state,
        ...action.stats,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        requests: updateRequestState(state, action),
      }
    default:
      return state
  }
}

export const setSelectedRequest = (request) => {
  return {
    type: SET_REQUEST,
    request,
  }
}

const setStats = (stats) => {
  return {
    type: SET_STATS,
    stats,
  }
}

const setRequests = (requests) => {
  return {
    type: SET_REQUESTS,
    requests,
  }
}

export const createMaintenanceRequest = (buildingId, requestData) => {
  return async (dispatch) => {
    try {
      await API.createMaintenance(requestData)
      await fetchMaintenanceRequests(buildingId, {
        search: '',
        type: '',
        status: [],
        limit: 50,
        skip: 0,
        updatedAtSort: 'DESC',
      })(dispatch)
      return Promise.resolve()
    } catch (e) {
      return Promise.reject(e)
    }
  }
}

export const fetchMaintenanceRequests = (buildingId, data) => {
  const dataToSend = {
    ...data,
    dateTo: data.dateTo && fromZonedTime(endOfDay(data.dateTo), 'UTC').getTime(),
    dateFrom: data.dateFrom && fromZonedTime(data.dateFrom, 'UTC').getTime(),
  }

  return (dispatch) =>
    API.getMaintenanceRequestsByBuildingId({
      ...dataToSend,
      buildingId: Number(buildingId),
    })
      .then((res) => {
        const { maintenanceRequests, ...stats } = res.data
        dispatch(setRequests(maintenanceRequests))
        dispatch(setStats({ ...stats, allCount: maintenanceRequests.length }))
        return Promise.resolve(maintenanceRequests)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateSelectedMaintenanceRequest = (requestId, payload, dataToUpdate) => {
  return (dispatch) =>
    API.updateMaintenanceRequest(requestId, payload)
      .then(() => {
        dispatch(setSelectedRequest(dataToUpdate))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const selectRequests = (state) => state.maintenance.requests
export const selectRequest = (state) => state.maintenance.request
export const selectStats = ({
  maintenance: { scheduledCount, pendingCount, completedCount, allCount },
}) => ({
  scheduledCount,
  pendingCount,
  completedCount,
  allCount,
})

export const selectRequestById = createSelector(selectRequests, (requests) => (requestId) => {
  return requests.find((request) => request.id === Number(requestId))
})

export default maintenanceReducer
